// extracted by mini-css-extract-plugin
export default {"digital_clock_container":"digital-clock_digital_clock_container__LdtNS"};